export enum ArchivedEnum {
  ALL = "ALL",
  ONLY_ACTIVE = "0",
  ONLY_ARCHIVED = "1"
}

